import { create } from 'zustand';
import { combine, devtools } from 'zustand/middleware';
import { createSelectors } from './selectors';

// TODO: consider removing this store
const store = create(
  devtools(
    combine(
      {
        modal_id: '',
        popover_id: '',
      },
      (set) => ({
        setDetectModalId: (modal_id: string) => {
          set({ modal_id });
        },
        clearDetectModalId: () => {
          set({ modal_id: '' });
        },
        setDetectPopoverId: (popover_id: string) => {
          set({ popover_id });
        },
        clearDetectPopoverId: () => {
          set({ popover_id: '' });
        },
      })
    )
  )
);

export const useDetectModalStore = createSelectors(store);
